import React, { useState, useEffect, useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import {
  DataGridPro,
  GridToolbarContainer, GridToolbarExport
} from "@mui/x-data-grid-pro";
import moment from 'moment';
import { Auth } from 'aws-amplify';
import IconButton from '@mui/material/IconButton';
import EditIcon from '@mui/icons-material/Edit';
import { REACT_APP_STOP_BASE_URL, CBP_INVOICE_LOCK_URL, CBP_INVOICE_ADD_HISTORY_URL, dateFormat, paginationSize } from '../../../constants';
import { useDispatch, useSelector } from 'react-redux';
import { getCbpInvoiceList, lockOrUnlock, addHistory } from './services/cbpInvoiceListApi';
import CommonSearch from '../../common/Search/CommonSearch';
import { renderCellExpand } from '../../common/GridCell/GridCellExpand';
import { getCbpInvoiceDetail } from '../../../redux/invoices/cbpInvoiceDetail/cbpInvoiceDetailSlice';
import CbpInvoiceListDialog from './CbpInvoiceListDialog';
import { getHeading } from '../../common/commonUtils/commonUtils';
import { commonQueryParams } from '../../../services/QueryParams/QueryParams';

import PageHeading from '../../common/Heading/PageHeading';
import Button from '@mui/material/Button';
import Grid from '@mui/material/Grid';
import { ContentTitle, RightButton } from '../../ui/styled';
import Box from '@mui/material/Box';
import TextField from '@mui/material/TextField';
import FormHelperText from '@mui/material/FormHelperText';
import BackIcon from '../../common/Back/BackIcon';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import { LeftGrid } from '../../Episode/Episode.Styled';
import InvoiceListPrintDialog from './InvoiceListPrintDialog';
import InvoiceListPrintModalityDialog from './InvoiceListPrintModalityDialog';

const CbpInvoiceList = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [user, setUser] = useState(null);
  const [lockDate, setLockDate] = useState(null);
  const [searchCbpInvoiceList, setSearchCbpInvoiceList] = useState('');
  const [visibleRows, setVisibleRows] = React.useState([]);
  const [invoicesByModality, setInvoicesByModality] = React.useState([]);
  const [visibleInvIds, setVisibleInvIds] = React.useState('');
  //const apiRef = useGridApiRef();
  const [openCbpInvoiceDetailDialog, setOpenCbpInvoiceDetailDialog] =
  useState(false);
  const [openBackdrop, setOpenBackdrop] = useState(false);
  const [cbpInvoiceListData, setCbpInvoiceListData] = useState({
    isLoading: false,
    data: [],
    pageSize: 250,
    total: 0,
    page: 1,
    sortModel: '',
    filterModel: {}
  });
  const [openPrintDialog, setOpenPrintDialog] = useState(false);
  const [openPrintModalityDialog, setOpenPrintModalityDialog] = useState(false);

  const invoiceCbpIds = useSelector((state) => state.invoiceCbpIds);

  useEffect(() => {
    if (user?.signInUserSession.accessToken.jwtToken) {
      fetchData();
    }
    getUser().then((userData) => setUser(userData));
  }, [
    user?.signInUserSession.accessToken.jwtToken,
    cbpInvoiceListData.page,
    cbpInvoiceListData.pageSize,
    cbpInvoiceListData.sortModel,
    cbpInvoiceListData.filterModel,
    searchCbpInvoiceList,
    ]);

  //useEffect(() => {
  //  apiRef.current.subscribeEvent("stateChange", () => {
  //    const rows = gridFilteredSortedRowEntriesSelector(apiRef.current.state);
  //    setVisibleRows(rows);
  //    let IDs = '';
  //    rows.forEach(function (item) {
  //      IDs += (item.model.CbpInvID + ','); 
  //    });
  //    setVisibleInvIds(IDs.slice(0, -1));
  //
  //  });
  //}, [apiRef]);

  const getUser = () => {
    return Auth.currentAuthenticatedUser()
    .then((userData) => userData)
    .catch(() => console.log('Not signed in'));
  };

  const QuickSearchToolbar = () => {
    return (
      <Box pt={1} sx={{ flexGrow: 1, backgroundColor: '#747070' }}>
        <Grid container spacing={1}>
          <Grid item xs={11}>
            <CommonSearch
              searchText={searchCbpInvoiceList}
              setSearchText={setSearchCbpInvoiceList}
            />
          </Grid>
          <Grid item xs={1}>  
            <GridToolbarContainer>
              <GridToolbarExport />
            </GridToolbarContainer>
          </Grid>
        </Grid>    
      </Box>  
    );
  };

  const fetchData = async () => {
    setCbpInvoiceListData((prveState) => ({ ...prveState, isLoading: true }));
    //let url
    //if (invoiceCbpIds) {
    //  url = `${CBP_INVOICE_LIST_URL}${invoiceCbpIds}`;
    //}
    //else {
    const url = `${REACT_APP_STOP_BASE_URL}api/Invoice/List`;
    //}
    const commonParams = commonQueryParams(
      url,
      searchCbpInvoiceList,
      cbpInvoiceListData
    );
    const authorization = `${user?.signInUserSession.accessToken.jwtToken}`;
    const cbpInvoiceList = await getCbpInvoiceList({
      commonParams,
      authorization,
    });

    let IDs = '';
    cbpInvoiceList.data.forEach(function (item) {
      IDs += (item.CbpInvID + ','); 
    });
    setVisibleInvIds(IDs.slice(0, -1));

    const groupedInvoices = cbpInvoiceList.data.reduce(function (r, a) {
      r[a.Modality] = r[a.Modality] || [];
      r[a.Modality].push(a);
      return r;
    }, Object.create(null));
    //console.log('### groupedInvices');
    //console.log(groupedInvices);
    //for (let [key, value] of Object.entries(groupedInvoices)) {
    //  console.log(key, value);
    //}
    setInvoicesByModality(groupedInvoices);


    setCbpInvoiceListData((prveState) => ({
      ...prveState,
      ...cbpInvoiceList,
    }));
  };

  const handleSortModelChange = useCallback((sortModel) => {
    setCbpInvoiceListData((old) => ({ ...old, sortModel: [...sortModel] }));
  }, []);

  const updateCBpInvoiceList = (params) => {
    const { row } = params;
    const cbpInvoiceDetail = {
      CbpInvID: row.CbpInvID,
      DateFaxed: row.DateFaxedWithOutFormate,
      DateRecived: row.DateRecivedWithOutFormate,
      Signed: row.Signed,
    };
    dispatch(getCbpInvoiceDetail(cbpInvoiceDetail));
    setOpenBackdrop(true);
    setTimeout(() => {
      setOpenBackdrop(false);
    }, 1000);
    setOpenCbpInvoiceDetailDialog(true);
  };

  const handleLockDate = (e) => setLockDate(e.target.value);
  
  const handleLock = () => {
    //console.log(visibleInvIds);    
    const url = `${CBP_INVOICE_LOCK_URL}${visibleInvIds}&date=${lockDate}`;
    const authorization = `${user?.signInUserSession.accessToken.jwtToken}`;
    lockOrUnlock({ url, authorization }).then((response) => {
        //if (response.succeeded === true) {
          //console.log(response)
      fetchData();
        //}
    });
  }  
  
  const handleUnlock = () => {
    const url = `${CBP_INVOICE_LOCK_URL}${visibleInvIds}`;
    const authorization = `${user?.signInUserSession.accessToken.jwtToken}`;
    lockOrUnlock({ url, authorization }).then((response) => {
      fetchData();
    });
  }
  
  const handleAddToHistory = () => {
    const url = `${CBP_INVOICE_ADD_HISTORY_URL}${visibleInvIds}`;
    const authorization = `${user?.signInUserSession.accessToken.jwtToken}`;
    addHistory({ url, authorization }).then((response) => {
      fetchData();
    });
  }
  
  const handleOpenHistory = () => {
    navigate('/invoice/invoiceHistoryList');  
  }

  const handlePrint = () => {
    setOpenPrintDialog(true);  
  }

  const handlePrintModality = () => {
    setOpenPrintModalityDialog(true);  
  }

  const handleFilterChange = useCallback((filterModel) => {
    // Here you save the data you need from the filter model
    //console.log(filterModel);
    console.log(filterModel);
    setCbpInvoiceListData((old) => ({ ...old, filterModel: {...filterModel} }));
  }, []);
  
  const columnsData = [
  {
    field: 'actions',
    headerName: 'Actions',
    width: 70,
    type: 'actions',
    renderCell: (params) => {
      return (
        <IconButton onClick={() => updateCBpInvoiceList(params)}>
        <EditIcon />
        </IconButton>
        );
    },
  },
  {
    field: 'CbpInvID',
    headerName: 'Cbp Invoice Id',
  },
  {
    field: 'CBPProvider',
    headerName: 'CBP Provider',
    minWidth: 300,
    renderCell: renderCellExpand,
  },
  { field: 'CbpID', headerName: 'Cbp Id' },
  { field: 'Month', headerName: 'Month' },
  { field: 'Modality', headerName: 'Modality' },
  {
    field: 'DateSentLocked',
    headerName: 'Date Sent Locked',
    renderCell: (params) => {
      return (
        <Typography>{params.value ? moment(params.value).format(dateFormat) : ''}</Typography>
        );
    },
  },
  { field: 'DateFaxed', headerName: 'Date Faxed', type: 'date' },
  { field: 'DateReceived', headerName: 'Date Recived', type: 'date' },
  { field: 'Signed', headerName: 'Signed', type: 'boolean' },
  { field: 'CreditTmt', headerName: 'Credit Tmt' },
  { field: 'OutMthTmt', headerName: 'Out Month Tmt' },
  { field: 'InMthTmt', headerName: 'In Month Tmt' },
  { field: 'AllTmt', headerName: 'All Tmt' },
  { field: 'InvoiceAmt', headerName: 'Invoice Amount' },
  { field: 'DCPAdj', headerName: 'DCP Adj' },
  ];

  return (
    <>
    <Box>
      <ContentTitle container>
        <Grid item xs={2}>
          <Box style={{ display: 'flex', alignItems: 'center' }}>
            <BackIcon />
            <PageHeading title='Invoice List' />
          </Box>
        </Grid>
        <Grid item xs={6}>
          <Stack spacing={1} direction="row">
            <Button variant='contained' onClick={() => handleUnlock()}>
              Unlock
            </Button>
            <Button variant='contained' onClick={() => handleLock()}>
              Lock
            </Button>
            <Typography variant="h5" style={{ marginTop: '9px' }}>
              Invoices with this Sent Date
            </Typography>
            <TextField 
              id="lock-date" 
              variant="outlined" 
              type="date"
              onChange={(e) => handleLockDate(e)} 
            />
          </Stack>
        </Grid>

        <LeftGrid item xs={4}>
          <Button
            variant="contained"
            style={{ justifyContent: 'flex-end' }}
            onClick={handlePrint}
          >
            Print Preview
          </Button>
          <RightButton
            variant="contained"
            onClick={handlePrintModality}
          >
            Print by Modality Preview
          </RightButton>
        </LeftGrid>

    </ContentTitle>
    </Box>
    <DataGridPro
    filterMode="server"
    onFilterModelChange={handleFilterChange}
    //apiRef={apiRef}
    autoHeight
    //getRowHeight={() => 'auto'}
    columns={columnsData}
    rows={cbpInvoiceListData.data}
    pageSize={cbpInvoiceListData.pageSize}
    page={cbpInvoiceListData.page - 1}
    rowCount={cbpInvoiceListData.total}
    paginationMode='server'
    sortingMode='server'
    onPageSizeChange={(newPageSize) =>
    setCbpInvoiceListData((prveState) => ({
      ...prveState,
      pageSize: newPageSize,
    }))
    }
    onPageChange={(newPage) => {
      setCbpInvoiceListData((prveState) => ({
        ...prveState,
        page: newPage + 1,
      }));
    }}
    rowsPerPageOptions={paginationSize}
    pagination
    components={{ Toolbar: QuickSearchToolbar }}
    experimentalFeatures={{ newEditingApi: true }}
    onSortModelChange={handleSortModelChange}
    getRowClassName={(params) =>
    params.indexRelativeToCurrentPage % 2 === 0 ? 'even' : 'odd'
    }
    loading={cbpInvoiceListData.isLoading}
    />
    {/**
    <p>
    Credit Tmt Total: 0<br/>
    Out Month Total: 0<br/>
    In Month Total: 0<br/>
    All Tmt Total: 0<br/>
    Invoice Total: 0<br/>
    DCP Adj Total: 0<br/>
    </p>
    **/}
    <CbpInvoiceListDialog
    open={openCbpInvoiceDetailDialog}
    setOpen={setOpenCbpInvoiceDetailDialog}
    authToken={user?.signInUserSession.accessToken.jwtToken}
    openBackdrop={openBackdrop}
    fetchData={fetchData}
    />
    <Grid container spacing={2} style={{ marginTop: '0px' }}>
      <Grid item xs={12} sm={3.2}>
        <Button
          variant='contained'
          //disabled={cbpInvoiceListData.filterModel?.items?.length === 0}
          onClick={() => handleAddToHistory()}
        >
          Add Visible Invoices To History List
        </Button>
      </Grid>
      <Grid item xs={12} sm={2.4}>
        <Button 
          variant='contained'
          onClick={() => handleOpenHistory()}
        >
          Open History List</Button>
      </Grid>
    </Grid>
    <InvoiceListPrintDialog
      search={searchCbpInvoiceList}
      filter={cbpInvoiceListData.filterModel}
      invoices={cbpInvoiceListData.data}
      openDialog={openPrintDialog}
      setOpenDialog={setOpenPrintDialog}
    />
    <InvoiceListPrintModalityDialog
      search={searchCbpInvoiceList}
      filter={cbpInvoiceListData.filterModel}
      invoices={invoicesByModality}
      openDialog={openPrintModalityDialog}
      setOpenDialog={setOpenPrintModalityDialog}
    />
    </>

  );
};

export default CbpInvoiceList;
